import { ValueProvider } from 'tsyringe';
import { HttpService } from '@/infrastructure/http/HttpService';

export const httpServiceProvider = (): ValueProvider<HttpService> => {
  const httpService = new HttpService(process.env.VUE_APP_MSAL_WEB_API_BASE_URL);
  return { useValue: httpService };
};
